import { render, staticRenderFns } from "./contractTypeSpecManageList.vue?vue&type=template&id=795588b8&scoped=true"
import script from "./contractTypeSpecManageList.vue?vue&type=script&lang=js"
export * from "./contractTypeSpecManageList.vue?vue&type=script&lang=js"
import style0 from "./contractTypeSpecManageList.vue?vue&type=style&index=0&id=795588b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795588b8",
  null
  
)

export default component.exports